import { ru } from 'date-fns/locale'
import { format, isSameDay as fnsIsSameDay, isValid, parseISO } from 'date-fns'
import * as O from 'fp-ts/es6/Option'
import { pipe } from 'fp-ts/es6/pipeable'
import { flow } from 'fp-ts/es6/function'
import { isToday } from 'date-fns/esm'

export const MONTHS = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
]

export const WEEKDAYS_LONG = [
    'Воскресенье',
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
]

export const WEEKDAYS_SHORT = [
    'вс',
    'пн',
    'вт',
    'ср',
    'чт',
    'пт',
    'сб',
]

export function parseDate(date?: string | number): Date | undefined {
    if (date) {
        const newDate = typeof date === 'string' ? parseISO(date): new Date(date)
        return isValid(newDate) ? newDate : undefined
    }
}

export const toDateString = (date?: Date): string => date ? format(date, 'dd.MM.yyyy', { locale: ru }) : ''

export const toReadableDateString = (date?: Date): string => date ? format(date, 'dd MMM y', { locale: ru }) : ''

export const toServerDate = (date?: Date): string => date ? format(date, 'yyyy-MM-dd') : ''

export const toTimeString = (date?: Date): string => date ? format(date, 'HH:mm') : ''

export const toDateTime = (date?: Date): string =>
    date ?
        format(date, `${isToday(date)? 'Сегодня': 'dd MMM yyyy'} • HH:mm`, { locale: ru }) :
        ''

export const isSameDay = (first?: string, second?: string): boolean => pipe(
    O.Do,
    O.bind('first', () => O.fromNullable(parseDate(first))),
    O.bind('second', () => O.fromNullable(parseDate(second))),
    O.chain(({ first, second }) => O.some(fnsIsSameDay(first, second))),
    O.getOrElseW(() => false)
)

export const processDate = flow(parseDate, toDateTime)